function createImageFromInitials(
  size: number,
  imageName: string,
  color: string
) {
  if (imageName == null) return "";
  const formattedImageName = getInitialName(imageName);
  const canvas = document.createElement("canvas");
  const context: any = canvas.getContext("2d");
  canvas.width = size;
  canvas.height = size;
  context.fillStyle = "#ffffff";
  context.fillRect(0, 0, size, size);
  context.fillStyle = `${color}50`;
  context.fillRect(0, 0, size, size);
  context.fillStyle = color;
  context.textBaseline = "middle";
  context.textAlign = "center";
  context.font = `${size / 2}px Montserrat`;
  context.fillText(formattedImageName, size / 2, size / 2);
  return canvas.toDataURL();
}

function getRandomColor() {
  const colors = ["#00a19d", "#415A6C", "#e05d5d"];
  return colors[Math.floor(Math.random() * colors.length)];
}

function getInitialName(name: string) {
  let initials;
  const nameSplit = name.split(" ");
  const nameLength = nameSplit.length;
  if (nameLength > 1) {
    initials =
      nameSplit[0].substring(0, 1) + nameSplit[nameLength - 1].substring(0, 1);
  } else if (nameLength === 1) {
    initials = nameSplit[0].substring(0, 1);
  } else return "";
  return initials.toUpperCase();
}

function formatOrdinalNumber(d: number) {
  if (d > 3 && d < 21) return `${d}th`;
  switch (d % 10) {
    case 1:
      return `${d}st`;
    case 2:
      return `${d}nd`;
    case 3:
      return `${d}rd`;
    default:
      return `${d}th`;
  }
}

export {
  createImageFromInitials,
  getRandomColor,
  getInitialName,
  formatOrdinalNumber,
};
